<template lang="pug">
.payment-order-header
  .d-flex.flex-column.font-weight-bold.flex-shrink-1.flex-grow-1
    div {{ region.orgTitle }}
  div.flex-shrink-1.flex-grow-1 Тел.: {{ region.orgPhone }}
  div.flex-shrink-1.flex-grow-1.text-center
    v-btn.text-none.payment-button--space( plain text color="primary" @click="changeRegion" ) Сменить регион
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'PaymentOrderHeader',

  computed: {
    ...mapState('expert', ['region'])
  },

  methods: {
    changeRegion() {
      this.$router.push({ path: '/payment_order' })
    }
  }
}
</script>

<style scoped>
.payment-order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  height: 100px;
  margin: 0 auto;
  width: 1200px;
}

@media screen and (max-width: 1280px){
  .payment-order-header {
    width: 960px
  }
}

@media screen and (max-width: 980px) {
  .payment-order-header {
    flex-direction: column;
    align-items: flex-start;
    width: auto;
    height: 120px;
    margin: 35px;

    gap: 8px;
  }

  .payment-button--space {
    margin-top: 8px; 
    padding: 0px !important;
  }
  
}
</style>